import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, map, tap, switchMap} from 'rxjs/operators';
import { FreightValumeCalService } from '../../../../shared/services/freight-valume-cal.service';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
@Component({
    selector: 'app-freight-volume-calculator',
    templateUrl: './freight-volume-calculator.component.html',
    styleUrls: ['./freight-volume-calculator.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FreightVolumeCalculatorComponent implements OnInit {

  unitConvertorForm:UntypedFormGroup ;
  dimensionCalForm:UntypedFormGroup;
  dcFormArr:UntypedFormArray| undefined;
  constructor(private freightValumeCalService:FreightValumeCalService,private _fb:UntypedFormBuilder) {

    this.unitConvertorForm = this._fb.group({
        unitlength:new UntypedFormControl(""),
        unitLengthVal:new UntypedFormControl('',Validators.required),
        unitlengthRes:new UntypedFormControl(''),
        unitWeight:new UntypedFormControl(""),
        unitWeightVal:new UntypedFormControl('',Validators.required),
        unitWeightRes:new UntypedFormControl(''),
        unitValume:new UntypedFormControl(""),
        unitValumeVal:new UntypedFormControl('',Validators.required),
        unitValumeRes:new UntypedFormControl(''),
        unitTemp:new UntypedFormControl(""),
        unitTempVal:new UntypedFormControl('',Validators.required),
        unitTempRes:new UntypedFormControl('')
    })

    this.dimensionCalForm = this._fb.group({
      dcFormArr:this._fb.array([this.createNewDCFormControl()]) ,
  
      cbm:new UntypedFormControl(""),
      cbf: new UntypedFormControl(""),
    })

   }

  unitLengthList:any = [];
  unitWeightList:any = [];
  unitValumeList:any = [];
  unitTempList:any = [];
  name:any;
  units:any = [
    {name:'Centimeter',id:1},
    {name:'Feet',id:2},
    {name:'Inch',id:3},
    {name:'Meter',id:4},
  ]


  selectedDC:any;
  selectedUnitLength:any;
  selectedunitWeight:any;
  selectedunitValume:any;
  selectedunitTempList:any;


  unitlengthLoader:boolean = false;
  unitWeightLoader:boolean = false;
  unitValumeLoader:boolean = false;
  unitTempLoader:boolean = false;
  dimensionFromArr:UntypedFormArray | undefined;
 
  get dimensionFromArr1() : UntypedFormArray {
    return this.dimensionCalForm.get("dimensionFromArr") as UntypedFormArray
  }

  createNewDCFormControl(): UntypedFormGroup {
    return this._fb.group({
      numberOfPieces:new UntypedFormControl("",[Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      lengthOfPieces:new UntypedFormControl("",[Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      widthPiece:new UntypedFormControl("",[Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      heightPiece:new UntypedFormControl("",[Validators.required,Validators.pattern(/^-?(0|[1-9]\d*)?$/)]),
      cbm1:new UntypedFormControl(0),
      cbf1: new UntypedFormControl(0),
      unit:new UntypedFormControl(""),
    })
  }

isRemoveFalg:boolean = false;
 addNewDCForm(): void {
  // this.isRemoveFalg = true;
  this.dcFormArr = this.dimensionCalForm.get('dcFormArr') as UntypedFormArray;
  this.dcFormArr.push(this.createNewDCFormControl());
 // console.log(this.dcFormArr.length)
  if(this.dcFormArr.length > 1){
      this.isRemoveFalg = true;
  }else{
    this.isRemoveFalg = false;
  } 
  // console.log(this.dimensionCalForm.valid)
 }
 removeDCForm(index:any): void {
  this.dcFormArr = this.dimensionCalForm.get('dcFormArr') as UntypedFormArray;
  this.dcFormArr.removeAt(index);
  if(this.dcFormArr.length > 1){
    this.isRemoveFalg = true;
  }else{
  this.isRemoveFalg = false;
  } 

  if((this.dcFormArr.value[0].unit) != ''){
    this.calcaulateGrandTotal();
  }
}
 

  ngOnInit(): void {
    this.freightValumeCalService.getOFVCLength({iUnitId:1}).subscribe((res)=>{
      this.unitLengthList = [];
      let unitLengthListReq:any  = res;
      let tempArr:any = [];

        unitLengthListReq && unitLengthListReq.forEach((el1:any,el1Index:any) => {
          unitLengthListReq && unitLengthListReq.forEach((el2:any,el2index:any) => {
            if(el2!==el1){
              let tempob = {
                iUnitFromId:el1.I_UNIT_ID,
                iUnitToId:el2.I_UNIT_ID,
                C_NAME:el1.C_NAME + '-' + el2.C_NAME
              }
              tempArr.push(tempob);
            }
          });
        });
       // console.log(tempArr)
        this.unitLengthList = tempArr;
       // console.log(this.unitLengthList)
    })
    this.freightValumeCalService.getOFVCLength({iUnitId:2}).subscribe((res)=>{
      this.unitWeightList = [];
      let unitWeightListReq:any  = res;
      let tempArr :any = [];
      
      unitWeightListReq && unitWeightListReq.forEach((el1:any,el1Index:any) => {
        unitWeightListReq && unitWeightListReq.forEach((el2:any,el2index:any) => {
            if(el2!==el1){
              let tempob = {
                iUnitFromId:el1.I_UNIT_ID,
                iUnitToId:el2.I_UNIT_ID,
                C_NAME:el1.C_NAME + '-' + el2.C_NAME
              }
              tempArr.push(tempob);
            }
          });
        });
        this.unitWeightList = tempArr;
    })
    this.freightValumeCalService.getOFVCLength({iUnitId:3}).subscribe((res)=>{
     
        this.unitValumeList = [];
        let unitValumeListReq:any  = res;
        let tempArr:any = [];
        
        unitValumeListReq && unitValumeListReq.forEach((el1:any,el1Index:any) => {
          unitValumeListReq && unitValumeListReq.forEach((el2:any,el2index:any) => {
              if(el2!==el1){
                let tempob = {
                  iUnitFromId:el1.I_UNIT_ID,
                  iUnitToId:el2.I_UNIT_ID,
                  C_NAME:el1.C_NAME + '-' + el2.C_NAME
                }
                tempArr.push(tempob);
              }
            });
          });
          this.unitValumeList = tempArr;
    })
    this.freightValumeCalService.getOFVCLength({iUnitId:4}).subscribe((res)=>{
      this.unitTempList = [];
      let unitTempListReq:any  = res;
      let tempArr:any = [];
      
      unitTempListReq && unitTempListReq.forEach((el1:any,el1Index:any) => {
        unitTempListReq && unitTempListReq.forEach((el2:any,el2index:any) => {
            if(el2!==el1){
              let tempob = {
                iUnitFromId:el1.I_UNIT_ID,
                iUnitToId:el2.I_UNIT_ID,
                C_NAME:el1.C_NAME + '-' + el2.C_NAME
              }
              tempArr.push(tempob);
            }
          });
        });
        this.unitTempList = tempArr;
    })

  }
  get f() { return this.unitConvertorForm.controls; }
  get dimentionf() { return this.dimensionCalForm.get('dcFormArr') as UntypedFormArray; }
  onSelectDC(){

  }

  onSelectUnitLength(e:any){
    if(parseInt(this.unitConvertorForm?.get('unitLengthVal')!.value) && (this.unitConvertorForm?.get('unitlength')!.value!=='' && this.unitConvertorForm?.get('unitlength')!.value!=='false')){
      this.unitlengthLoader = true;
      //console.log(this.unitConvertorForm.get('unitlength').value,this.unitConvertorForm.get('unitLengthVal').value);
      let obj = {
         ...this.unitConvertorForm?.get('unitlength')!.value,
         iTobeConverted:this.unitConvertorForm?.get('unitLengthVal')!.value
      }
      delete obj.C_NAME;
      this.freightValumeCalService.getLengthRes(obj).subscribe((res)=>{
        this.unitConvertorForm.get('unitlengthRes')!.setValue(res);
        this.unitlengthLoader = false;
      },(error)=>{
        this.unitConvertorForm.get('unitlengthRes')!.setValue("");
        this.unitlengthLoader = false;
      })
    } 
  }

  onSelecteUnitWeight(){
    if(parseInt(this.unitConvertorForm.get('unitWeightVal')!.value) && (this.unitConvertorForm.get('unitWeight')!.value!=='' && this.unitConvertorForm.get('unitWeight')!.value!=='false')){
      this.unitWeightLoader = true;
      //console.log(this.unitConvertorForm.get('unitlength').value,this.unitConvertorForm.get('unitLengthVal').value);
      let obj = {
         ...this.unitConvertorForm.get('unitWeight')!.value,
         iTobeConverted:this.unitConvertorForm.get('unitWeightVal')!.value
      }
      delete obj.C_NAME;
      this.freightValumeCalService.getLengthRes(obj).subscribe((res)=>{
        this.unitConvertorForm.get('unitWeightRes')!.setValue(res);
        this.unitWeightLoader = false;
      },(error)=>{
        this.unitConvertorForm.get('unitWeightRes')!.setValue("");
        this.unitWeightLoader = false;
      })
    }
  }

  onSelecteUnitValume(){
    if(parseInt(this.unitConvertorForm.get('unitValumeVal')!.value) && (this.unitConvertorForm.get('unitValume')!.value!=='' && this.unitConvertorForm.get('unitValume')!.value!=='false')){
      this.unitValumeLoader = true;
      //console.log(this.unitConvertorForm.get('unitlength').value,this.unitConvertorForm.get('unitLengthVal').value);
      let obj = {
         ...this.unitConvertorForm.get('unitValume')!.value,
         iTobeConverted:this.unitConvertorForm.get('unitValumeVal')!.value
      }
      delete obj.C_NAME;
      this.freightValumeCalService.getLengthRes(obj).subscribe((res)=>{
        this.unitConvertorForm.get('unitValumeRes')!.setValue(res);
        this.unitValumeLoader = false;
      },(error)=>{
        this.unitConvertorForm.get('unitValumeRes')!.setValue("");
        this.unitValumeLoader = false;
      })
    }
  }

  onSelecteUnitTempList(){
    if(parseInt(this.unitConvertorForm.get('unitTempVal')!.value) && (this.unitConvertorForm.get('unitTemp')!.value!=='' && this.unitConvertorForm.get('unitTemp')!.value!=='false')){
      this.unitTempLoader = true;
      //console.log(this.unitConvertorForm.get('unitlength').value,this.unitConvertorForm.get('unitLengthVal').value);
      let obj = {
         ...this.unitConvertorForm.get('unitTemp')!.value,
         iTobeConverted:this.unitConvertorForm.get('unitTempVal')!.value
      }
      delete obj.C_NAME;
      this.freightValumeCalService.getLengthRes(obj).subscribe((res)=>{
        this.unitConvertorForm?.get('unitTempRes')!.setValue(res);
        this.unitTempLoader = false;
      },(error)=>{
        this.unitConvertorForm?.get('unitTempRes')!.setValue("");
        this.unitTempLoader = false;
      })
    }
  }


  VOLUME:any = 0;
  CBM:any = 0;
  CBF:any= 0;

  onDMHeightChange(currControl:any,currentIndex:any){

    // console.log(this.dimensionCalForm,currentIndex,currControl.get('lengthOfPieces').value);
      //  if(this.dimensionCalForm.valid){

        // console.log(this.dimensionCalForm);
        this.VOLUME = 0;
        this.VOLUME = currControl.get('lengthOfPieces').value * currControl.get('widthPiece').value * currControl.get('heightPiece').value * currControl.get('numberOfPieces').value ;
        
        let cbm1:any = 0;
        let cbf1:any = 0;
        switch (currControl.get('unit').value) {
          case "1":
            // CENTIMETER
            cbm1 = this.VOLUME / 1000000;
            cbf1 = this.VOLUME * 35.314 /1000000;
           currControl.get('cbm1').setValue(cbm1.toFixed(3));
           currControl.get('cbf1').setValue(cbf1.toFixed(3));
           // console.log('Is Centimeter' ,  cbf1.toFixed(3))
            break;
          case "2":
            // FEET 
            cbm1 = this.VOLUME * 0.02832;
            cbf1 = this.VOLUME 
           currControl.get('cbm1').setValue(cbm1.toFixed(3));
           currControl.get('cbf1').setValue(cbf1.toFixed(3));
            break;
          case "3":
            // INCH
            this.VOLUME = (this.VOLUME/(12 * 12 * 12))
            cbm1 = (this.VOLUME*0.02832)
            //  cbm1 = (this.VOLUME / (12*12*12))*0.02832 ;
            cbf1 = this.VOLUME * 1000 / 1000
            currControl.get('cbm1').setValue(cbm1.toFixed(3));
            currControl.get('cbf1').setValue(cbf1.toFixed(3));
            break;
          case "4":
            // METER
            cbm1 = this.VOLUME;
            cbf1 = this.VOLUME * 35.314;
            currControl.get('cbm1').setValue(cbm1.toFixed(3));
            currControl.get('cbf1').setValue(cbf1.toFixed(3));
           break;
          default:
            break;
        }


       // console.log(this.dimensionCalForm.value.dcFormArr)
        this.calcaulateGrandTotal();
        
  }

  calcaulateGrandTotal(){
    let sumCBM = 0;
    let sumCBF = 0;
    this.dimensionCalForm.value.dcFormArr.forEach((item:any)=>{
      sumCBM = sumCBM +  parseFloat(item.cbm1);
      sumCBF = sumCBF +  parseFloat(item.cbf1);
    })

    this.dimensionCalForm?.get('cbm')!.setValue(sumCBM.toFixed(3));
    this.dimensionCalForm?.get('cbf')!.setValue(sumCBF.toFixed(3));
  }

  numberOnly(event:any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    } 
    return true;
  }
  onValuePaste(event: ClipboardEvent) {
    if(Number(event?.clipboardData?.getData('text'))){
        return true
    }
    return false
    // return false;
  }

}
